import React, { useEffect, useState } from 'react';
import { Card, BlockStack, InlineStack, Text, Button, Banner } from '@shopify/polaris';

const money = value => Number(value || 0).toFixed(2);

export default function EditModeBar({ changeCount, total, onReview, onCancel, reviewDisabled = false }) {
  const [confirming, setConfirming] = useState(false);

  // Undoing the last change must not leave a stale discard prompt behind.
  useEffect(() => {
    if (changeCount === 0) setConfirming(false);
  }, [changeCount]);

  const handleCancel = () => {
    if (changeCount > 0) {
      setConfirming(true);
    } else {
      onCancel();
    }
  };

  return (
    <Card>
      <BlockStack gap="300">
        <InlineStack align="space-between" blockAlign="center" gap="400" wrap>
          <InlineStack gap="400" blockAlign="center">
            <Text as="span" variant="headingSm">
              {changeCount === 1 ? '1 change' : `${changeCount} changes`}
            </Text>
            {typeof total === 'number' && (
              <Text as="span">New total: {money(total)}</Text>
            )}
          </InlineStack>
          <InlineStack gap="200">
            <Button onClick={handleCancel}>Cancel</Button>
            <Button variant="primary" disabled={changeCount === 0 || reviewDisabled} onClick={onReview}>
              Review changes
            </Button>
          </InlineStack>
        </InlineStack>
        {confirming && (
          <Banner
            tone="warning"
            title="Discard your changes?"
            action={{ content: 'Discard changes', onAction: onCancel }}
            secondaryAction={{ content: 'Keep editing', onAction: () => setConfirming(false) }}
          >
            <p>Your edits to this order have not been saved.</p>
          </Banner>
        )}
      </BlockStack>
    </Card>
  );
}
